import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { fmtNum } from "../lib/format";

// Read-only, ledger-derived owned total with a click-through location breakdown (C3).
// `rows` = [{ label, qty }]; only Admin gets the interactive popover.
export const OwnedBreakdown = ({ total = 0, rows = [], canView = true, testid }) => {
  const positive = (rows || []).filter(r => Number(r.qty) > 0);
  if (!canView || positive.length === 0) {
    return <span className="num font-semibold" data-testid={testid}>{fmtNum(total || 0)}</span>;
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="num font-semibold text-slate-900 underline decoration-dotted underline-offset-4 hover:text-emerald-700 cursor-pointer"
        >
          {fmtNum(total || 0)}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-0" data-testid={`${testid}-breakdown`}>
        <div className="px-3 py-2 border-b bg-slate-50 text-xs font-semibold text-slate-600">Location-wise breakdown</div>
        <div className="max-h-64 overflow-y-auto">
          {positive.map((r, i) => (
            <div key={r.label + i} className="flex items-center justify-between px-3 py-1.5 text-sm border-b last:border-0">
              <span className="text-slate-600">{r.label}</span>
              <span className="font-semibold text-slate-900">{fmtNum(r.qty)}</span>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-between px-3 py-2 bg-slate-900 text-white text-sm font-semibold rounded-b-md">
          <span>Owned Total</span><span data-testid={`${testid}-total`}>{fmtNum(total || 0)}</span>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default OwnedBreakdown;
